import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CheckIcon, ArrowRightIcon } from 'lucide-react';
import { trackMetaEvent } from '../utils/metaPixel';
type PackId = 'base' | 'premium';
interface PackItem {
  text: string;
  highlight?: boolean;
}
interface Pack {
  id: PackId;
  name: string;
  tag?: string;
  price: string;
  originalPrice: string;
  href: string;
  includes: PackItem[];
}
const PACKS: Pack[] = [{
  id: 'base',
  name: 'Pack Base',
  price: 'USD 13,99',
  originalPrice: 'USD 25,99',
  href: 'https://pay.hotmart.com/C107152723U?checkoutMode=10',
  includes: [{
    text: 'La Biblia en Cómic completa en PDF'
  }, {
    text: 'BONUS: Sopa de letras de la Biblia'
  }, {
    text: 'BONUS: 25 enseñanzas divinas para niños'
  }, {
    text: 'BONUS: 30 días de oración con versículos del Pentateuco'
  }]
}, {
  id: 'premium',
  name: 'Megapack Premium',
  tag: 'Más elegido',
  price: 'USD 19,99',
  originalPrice: 'USD 42,99',
  href: 'https://pay.hotmart.com/M107165222U?checkoutMode=10',
  includes: [{
    text: 'Todo lo del Pack Base incluido'
  }, {
    text: '4 películas animadas: David y Goliat, Sansón, Job y Ester',
    highlight: true
  }, {
    text: '65 historias en audio del Antiguo y Nuevo Testamento',
    highlight: true
  }]
}];
export function OfferSection() {
  const [selectedId, setSelectedId] = useState<PackId>('premium');
  const selected = PACKS.find(pack => pack.id === selectedId) ?? PACKS[1];
  return <section id="oferta" className="w-full scroll-mt-4 bg-[#10243D]" data-id="element-93" data-mp="1glgky7vbxa00">
      <div className="mx-auto max-w-6xl px-4 py-10 md:py-12" data-id="element-94" data-mp="1cjv46bfocbkj">
        <h2 className="mx-auto max-w-3xl text-center font-display text-3xl font-bold leading-tight text-white md:text-[40px]" data-id="element-95" data-mp="17neehcsttp5c">
          Menos de lo que cuesta una pizza. Dura toda su infancia.
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-[15px] text-cream/70" data-id="element-96" data-mp="3sbsqbs7ws77z">
          Elige el pack que quieres llevarte hoy:
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.55
      }} className="mx-auto mt-7 max-w-lg rounded-card border border-gold/70 bg-deep-blue p-5 shadow-2xl md:p-7" data-id="element-97" data-mp="3ts6jio3vbkdk">
          <div role="radiogroup" aria-label="Elige tu pack" className="space-y-4" data-id="element-98" data-mp="3b3i1qb0olv60">
            {PACKS.map(pack => {
            const isSelected = pack.id === selectedId;
            return <button key={pack.id} type="button" role="radio" aria-checked={isSelected} onClick={() => setSelectedId(pack.id)} className={`w-full rounded-card border-2 p-5 text-left transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${isSelected ? 'border-[#75B989] bg-[#75B989]/10' : 'border-white/15 bg-white/5 hover:border-white/30'}`} data-id="element-99" data-mp="316n4dvg5a0tb">
                  <div className="flex items-start gap-3" data-id="element-100" data-mp="2mgacixs6p79s">
                    <span className={`mt-1 flex h-5 w-5 flex-none items-center justify-center rounded-full border-2 ${isSelected ? 'border-[#75B989] bg-[#75B989]' : 'border-white/40'}`} aria-hidden="true" data-id="element-101" data-mp="2ig8kzhg5xu88">
                      {isSelected && <CheckIcon className="h-3 w-3 text-deep-blue" strokeWidth={4} data-id="element-102" data-mp="3181dlarbldff" />}
                    </span>

                    <div className="min-w-0 flex-1" data-id="element-103" data-mp="3a87pwtba87d0">
                      <div className="flex flex-wrap items-center gap-2" data-id="element-104" data-mp="3a9iugvcjxj56">
                        <span className="font-display text-xl font-bold text-white" data-id="element-105" data-mp="18jtnl5v2iozc">
                          {pack.name}
                        </span>
                        {pack.tag && <span className="rounded-full bg-gold px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide text-deep-blue" data-id="element-106" data-mp="1i8lc140x6r5i">
                            {pack.tag}
                          </span>}
                      </div>

                      <div className="mt-1 flex items-end gap-2" data-id="element-107" data-mp="pmirtv8nadon">
                        <span className="text-base text-cream/40 line-through" data-id="element-108" data-mp="ujsnhsmmnlkx">
                          {pack.originalPrice}
                        </span>
                        <span className="font-display text-3xl font-black text-[#75B989]" data-id="element-109" data-mp="13kgrrvm7y7km">
                          {pack.price}
                        </span>
                      </div>

                      <ul className="mt-3 space-y-1.5" data-id="element-110" data-mp="2eyuayn611yub">
                        {pack.includes.map(item => <li key={item.text} className="flex items-start gap-2" data-id="element-111" data-mp="2p3kkpf7oa793">
                            <CheckIcon className={`mt-1 h-3.5 w-3.5 flex-none ${item.highlight ? 'text-gold' : 'text-[#9DD4AA]'}`} aria-hidden="true" data-id="element-112" data-mp="2k47wor52eu4x" />
                            <span className={`text-[14px] leading-snug ${item.highlight ? 'font-semibold text-gold' : 'text-cream/85'}`} data-id="element-113" data-mp="26c9w54pf66kd">
                              {item.text}
                            </span>
                          </li>)}
                      </ul>
                    </div>
                  </div>
                </button>;
          })}
          </div>

          <div className="mt-6 flex flex-col items-center" data-id="element-114" data-mp="1k3m9vte4p8b6">
            <a href={selected.href} onClick={() => trackMetaEvent('InitiateCheckout', {
            content_name: selected.name,
            value: selected.id === 'premium' ? 19.99 : 13.99,
            currency: 'USD'
          })} className="cta-pulse group inline-flex w-full items-center justify-center gap-2 rounded-xl bg-orange px-9 py-4 text-lg font-bold text-white shadow-cta transition-transform duration-200 hover:-translate-y-0.5 hover:brightness-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange md:text-xl" data-id="element-115" data-mp="1k21fq4vq7rdu">
              <span className="tracking-wide" data-id="element-116" data-mp="1yr7e5qmqpdko">
                COMPRAR {selected.name.toUpperCase()}
              </span>
              <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-117" data-mp="ndvezt1xdj4u" />
            </a>
            <p className="mt-2.5 text-center text-[13px] text-cream/80" data-id="element-118" data-mp="eypg6dmfyhqy">
              Pago único · Sin suscripciones · Acceso de por vida
            </p>
          </div>

          <div className="mt-6 rounded-card border border-[#75B989]/40 bg-[#75B989]/10 px-6 py-5 text-center" data-id="element-119" data-mp="ouipzp8rzx51">
            <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#75B989]/20" data-id="element-120" data-mp="jwqzmzns4j2y">
              <ShieldCheckIcon className="h-7 w-7 text-[#9DD4AA]" aria-hidden="true" data-id="element-121" data-mp="3s9en5o6d28j0" />
            </span>
            <p className="mt-3 font-display text-xl font-bold text-[#B6E1BE]" data-id="element-122" data-mp="3natpnwihu2y9">
              Garantía “Le va a encantar” — 7 días
            </p>
            <p className="mx-auto mt-2 max-w-sm text-[15px] leading-relaxed text-cream/80" data-id="element-123" data-mp="14evq8hh99qp">
              Descárgala, léesela, pruébala con tus hijos. Si no los atrapa, te
              devolvemos el 100% de tu dinero. Sin preguntas ni vueltas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}